import { render, staticRenderFns } from "./whole.vue?vue&type=template&id=7497fbd1"
import script from "./whole.vue?vue&type=script&lang=js"
export * from "./whole.vue?vue&type=script&lang=js"
import style0 from "./whole.vue?vue&type=style&index=0&id=7497fbd1&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports